import { getPatient } from '../actions/patients';

const asyncValidate = (values, dispatch, { initialValues }, key) =>
  new Promise((resolve, reject) => {
    if (!key) {
      resolve();
    }

    const value = values[key].trim();
    const label = key[0] + key.slice(1, 5) + ' ' + key.slice(5).toLowerCase();
    const message = label + ' must be unique.';

    if (!value || value === initialValues[key]) {
      resolve();
    } else {
      let input = value.trim().toLowerCase();
      if (key === 'PhoneNumber') {
        const phoneNumber = input.replace(/[()\s\-]/g, '');
        if (phoneNumber.length < 11 && !phoneNumber.startsWith('+1')) {
          input = '+1' + phoneNumber;
        } else if (phoneNumber.length < 12 && !phoneNumber.startsWith('+')) {
          input = '+' + phoneNumber;
        }
      }

      dispatch(getPatient('search', input)).then(response => {
        if (response.value.message === 'User not found') {
          resolve();
        } else {
          reject({ [key]: message });
        }
      });
    }
  });

export default asyncValidate;
